import {ShippingInformation} from '@wix/auto_sdk_ecom_current-cart';
import {
  SelectedCarrierServiceOptionModel,
  SelectedCarrierServiceOptionWithPrivateFields,
} from './SelectedCarrierServiceOption.model';

export class ShippingInfoModel {
  public selectedCarrierServiceOption: SelectedCarrierServiceOptionModel;

  constructor(params: ShippingInfoModel) {
    this.selectedCarrierServiceOption = params.selectedCarrierServiceOption;
  }

  public static fromSDK(shippingInfo: ShippingInformation) {
    return new ShippingInfoModel({
      selectedCarrierServiceOption: SelectedCarrierServiceOptionModel.fromSDK(
        shippingInfo?.selectedCarrierServiceOption as SelectedCarrierServiceOptionWithPrivateFields
      ),
    });
  }
}
